import React from 'react';
import './Terms.css';

function Terms() {
  return (
    <div className="terms-page">
      <div className="terms-container">
        <h1>Terms of Use</h1>
        <p className="update-date">Last updated: November 5, 2025</p>
        
        <section>
          <h2>Acceptance of Terms</h2>
          <p>By accessing and using our mobile applications, you accept and agree to be bound by these Terms of Use.</p>
        </section>

        <section>
          <h2>Use License</h2>
          <p>Permission is granted to use our applications for personal, non-commercial purposes.</p>
        </section>

        <section>
          <h2>Disclaimer</h2>
          <p>Our applications are provided "as is" without any warranties, expressed or implied.</p>
        </section>

        <section>
          <h2>Limitations</h2>
          <p>AppsDNA shall not be liable for any damages arising from the use of our applications.</p>
        </section>

        <section>
          <h2>Contact</h2>
          <p>For questions about these Terms, contact us at: <a href="mailto:team@appdna.ai">team@appdna.ai</a></p>
        </section>
      </div>
    </div>
  );
}

export default Terms;